import { type InternalTreeMapNode } from '../types/internal.js';
import type { NameAccessor } from '../types/treemap.js';
import { getNodesValueSum } from './get-nodes-value-sum.js';

export const getFilteredNodes = (
  nodes: InternalTreeMapNode[],
  selectedIds: string[],
  nameAccessor?: NameAccessor,
): InternalTreeMapNode[] => {
  if (!selectedIds.length) {
    return nodes;
  }

  if (!nameAccessor) {
    return getClustersMatchingSelectedNames(nodes, selectedIds);
  }

  return getClustersWithSelectedLeaves(nodes, selectedIds, nameAccessor);
};

const getClustersMatchingSelectedNames = (
  clusters: InternalTreeMapNode[],
  selectedIds: string[],
): InternalTreeMapNode[] =>
  clusters.filter((cluster) => selectedIds.includes(cluster.name));

const getClustersWithSelectedLeaves = (
  clusters: InternalTreeMapNode[],
  selectedIds: string[],
  nameAccessor: NameAccessor,
): InternalTreeMapNode[] => {
  const filteredClusters: InternalTreeMapNode[] = [];

  for (const cluster of clusters) {
    const matchingLeaves = cluster.children?.filter((leaf) =>
      selectedIds.includes(String(leaf[nameAccessor])),
    );

    if (matchingLeaves?.length) {
      filteredClusters.push({
        ...cluster,
        children: matchingLeaves,
        value: getNodesValueSum(matchingLeaves),
      });
    }
  }

  return filteredClusters;
};
